define('home/models/activities/CreateThreadActivity',[
    'home/models/activities/ThreadActivity',
], function (
    ThreadActivity
) {
    'use strict';

    return ThreadActivity.extend({
        defaults: {
            verb: 'create',
        },
    });
});

